import React, { useEffect } from 'react'
import Header2 from '../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import Banner from '../components/haseeb/Banner'
import BannerImg from '../assets/images/bannners/MainServicesPage.webp'
import { useLanguage } from '../contexts/LanguageContext'

const ServicePage = () => {
    const { t } = useLanguage();
    
    useEffect(() => {
        window.scrollTo(0,0);
    },[])
    
        return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>{t('seo.servicesTitle')}</title>
        <meta name="description" content={t('seo.servicesDescription')} />
    </Helmet>
    </HelmetProvider>
    <Header2/>
    <Banner
    BannerImg={BannerImg}
    />
    </>
  )
}

export default ServicePage